"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonSafeParse = void 0;
const defaultsDeep_1 = __importDefault(require("lodash/defaultsDeep"));
const toJsonForSchema_1 = require("./toJsonForSchema");
const extract_1 = require("../extract");
const jsonSafeParse = (value, schema, { withDefaults } = { withDefaults: true }) => {
    const results = (0, toJsonForSchema_1.toJsonForSchema)(schema).safeParse(value);
    const defaults = (0, extract_1.extractDefaults)(schema);
    const data = results.success
        ? results.data
        : typeof value === 'string'
            ? JSON.parse(value)
            : value;
    const unordered = withDefaults ? (0, defaultsDeep_1.default)(data, defaults) : data;
    const ordered = Object.keys(unordered)
        .sort()
        .reduce((obj, key) => {
        obj[key] = unordered[key];
        return obj;
    }, {});
    return Object.assign(Object.assign({}, results), { data: ordered });
};
exports.jsonSafeParse = jsonSafeParse;
//# sourceMappingURL=jsonSafeParse.js.map